module.exports = __webpack_public_path__ + "static/media/22a Combat Knee.ff2e2d3c.jpg";